export const stringify_get_params = (dateFilter) => {
    let query_params = "?"
    Object.keys(dateFilter).map((key) => {
        if(dateFilter[key]){
            if (query_params.length > 1 ) query_params+="&"
            query_params+=key+"="+dateFilter[key]
        }
    })
    return query_params
}